// extracted by mini-css-extract-plugin
export default {"roomFormContainer":"EnterRoomForm_roomFormContainer__wEBRk","content":"EnterRoomForm_content__IV99D","useSteps":"EnterRoomForm_useSteps__r7QJE"};